module.exports = __webpack_public_path__ + "assets/img/warrior-name-7a35aabe.png";